import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
	ButtonOpenAccount,
	Container,
	ContainerButton,
	Content,
	SubmitButtom,
	Subtitle,
	SubtitleMobile,
	Title,
	Wrapper,
} from "./styles";
import history from "../../services/history";
import NewLogoSVG from "../../components/NewLogo";

export default function InviteFriend() {
	const [paramsQuery] = useState(new URLSearchParams(useLocation().search));

	useEffect(() => {
		let username = paramsQuery.get("username");

		if (username) {
			localStorage.setItem("NICKNAME", username);
		}

		if (localStorage.getItem("TYPE_FRIEND")) {
			localStorage.removeItem("TYPE_FRIEND");
		}
	}, [paramsQuery]);

	function startJourney(params) {
		if (params.includes("NEW")) {
			localStorage.setItem("TYPE_FRIEND", "NEW_FRIEND");
			return history.push("/onboard/welcome");
		}

		localStorage.setItem("TYPE_FRIEND", "IS_INVESTOR");
		localStorage.removeItem("NICKNAME");
		return history.push("/onboard/login");
	}

	return (
		<Container>
			<NewLogoSVG />
			<Content>
				<Wrapper>
					<Title>Entre ou crie sua conta</Title>
					<Subtitle>
						No TradeMap, você encontra tudo sobre seus investimentos,
						convida amigos e ainda ganha prêmios!
					</Subtitle>
					<SubtitleMobile>
						Encontre tudo sobre seus investimentos, convida amigos e
						ainda ganha prêmios!
					</SubtitleMobile>
				</Wrapper>
				<ContainerButton>
					<SubmitButtom onClick={() => startJourney("NEW")}>
						Criar uma conta
					</SubmitButtom>
					<ButtonOpenAccount onClick={() => startJourney("LOGIN")}>
						Entrar na minha conta
					</ButtonOpenAccount>
				</ContainerButton>
			</Content>
		</Container>
	);
}
